import { render, staticRenderFns } from "./RewardCloud.vue?vue&type=template&id=bf698fe4&scoped=true"
import script from "./RewardCloud.vue?vue&type=script&lang=js"
export * from "./RewardCloud.vue?vue&type=script&lang=js"
import style0 from "./RewardCloud.vue?vue&type=style&index=0&id=bf698fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf698fe4",
  null
  
)

export default component.exports